import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=313a224b&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=313a224b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a224b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313a224b')) {
      api.createRecord('313a224b', component.options)
    } else {
      api.reload('313a224b', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=313a224b&scoped=true&", function () {
      api.rerender('313a224b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ogyq2c6sYiCu/JS/comp/Voucher.vue"
export default component.exports